import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import queryString from 'query-string';
import http from '../../services/http';
import Loader from '../loader/loader';

class ChangePasswordForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      values: {},
      errors: {},
      loading: false,
      successfullySent: false,
    };
  }

  onFieldChange = fieldName => e => {
    const { value } = e.target;

    this.setState(state => ({
      ...state,
      values: {
        ...state.values,
        [fieldName]: value,
      },
      errors: {
        ...state.errors,
        [fieldName]: null,
      },
    }));
  }

  getQueryParams = () => {
    const { email, code } = queryString.parse(window.location.search);

    return {
      UserName: email,
      Code: code,
    };
  }

  onSubmit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const { values } = this.state;

    const data = {
      ...values,
      ...this.getQueryParams(),
    };

    try {
      await http.post('/api/auth/reset-password', data);
      this.setState({ loading: false });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console

      this.setState({ loading: false });

      const errorMessage = 'Nie udało się wysłać danych!';
      NotificationManager.error(errorMessage, 'Błąd', 5000);

      const { errors } = error;

      if (errors) {
        this.setState({ errors });
      }

      return;
    }

    this.setState({ successfullySent: true });
  }

  renderField = (fieldName, label, props = {}) => {
    const { errors } = this.state;
    // eslint-disable-next-line react/destructuring-assignment
    const [error] = errors[fieldName] || [];

    return (
      <TextField
        onChange={this.onFieldChange(fieldName)}
        variant="outlined"
        label={label}
        error={!!error}
        helperText={error}
        fullWidth
        {...props}
      />
    );
  }

  render() {
    const { history } = this.props;
    const { loading, successfullySent } = this.state;

    return (
      <form className="registration-form-container" onSubmit={this.onSubmit} noValidate>
        {loading && <Loader />}

        {successfullySent ? (
          <div>
            <div className="reset-password-text-container">
              <Typography variant="body1">
                Hasło zostało zresetowane
              </Typography>
            </div>

            <div className="send-button-container">
              <Button size="large" variant="contained" color="primary" onClick={() => history.replace('/')}>
                OK
              </Button>
            </div>
          </div>
        ) : (
          <div>
            <div className="reset-password-text-container">
              <Typography variant="body1">
                Podaj nowe hasło
              </Typography>
            </div>

            <Grid container spacing={2}>
              <Grid item xs={12}>
                {this.renderField('Password', 'Hasło', { required: true, type: 'password' })}
              </Grid>
              <Grid item xs={12}>
                {this.renderField('PasswordConfirmation', 'Powtórz hasło', { required: true, type: 'password' })}
              </Grid>
            </Grid>

            <div className="send-button-container">
              <Button size="large" variant="contained" color="primary" type="submit">
                Wyślij
              </Button>
            </div>
          </div>
        )}
      </form>
    );
  }
}

ChangePasswordForm.propTypes = {
  history: PropTypes.shape({
    replace: PropTypes.func,
  }).isRequired,
};

export default withRouter(ChangePasswordForm);
